{
  "name": "frontend",
  "version": "2.2.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "prebuild": "node tools/build-info.js",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.2.1",
    "@angular/cdk": "^20.2.0",
    "@angular/common": "^20.2.1",
    "@angular/compiler": "^20.2.1",
    "@angular/core": "^20.2.1",
    "@angular/forms": "^20.2.1",
    "@angular/material": "^20.2.0",
    "@angular/material-luxon-adapter": "^20.2.7",
    "@angular/platform-browser": "^20.2.1",
    "@angular/platform-browser-dynamic": "^20.2.1",
    "@angular/router": "^20.2.1",
    "@azure/msal-angular": "^4.0.19",
    "@azure/msal-browser": "^4.21.1",
    "@types/luxon": "^3.7.1",
    "apexcharts": "^5.10.6",
    "jwt-decode": "^4.0.0",
    "luxon": "^3.7.2",
    "ng-apexcharts": "^2.4.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.2.0",
    "@angular/cli": "^20.2.0",
    "@angular/compiler-cli": "^20.2.1",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.2"
  }
}
